import{unstable_unsupportedProp as _0x5a61f1}from'@mui/utils';export default _0x5a61f1;